import { Dispatch, PropsWithChildren, SetStateAction, createContext, useContext, useMemo, useState } from 'react'
import { UseFormReturn, useForm } from 'react-hook-form'
import { WindTunnelStudyInput } from '@core/const'
import { WindTunnelStudyResponse } from '@/core/query'

const defaultFormValues: WindTunnelStudyInput = {
  outerArea: 0,
  height: 0,
}

interface WindTunnelStudyContext {
  form: UseFormReturn<WindTunnelStudyInput>
  result: WindTunnelStudyResponse | null
  setResult: Dispatch<SetStateAction<WindTunnelStudyResponse | null>>
}

const context = createContext<WindTunnelStudyContext | undefined>(undefined)

const useDefaultContextValues = () => {
  const form = useForm<WindTunnelStudyInput>({
    defaultValues: defaultFormValues,
  })

  const [result, setResult] = useState<WindTunnelStudyResponse | null>(null)

  return useMemo(() => ({
    form,
    result,
    setResult,
  }), [form, result])
}

export function WindTunnelStudyProvider ({ children }: PropsWithChildren) {
  const { Provider } = context
  const defaultContextValues = useDefaultContextValues()

  return (
    <Provider value={defaultContextValues}>
      {children}
    </Provider>
  )
}

export const useWindTunnelStudy = () => {
  const contextValues = useContext(context)
  const defaultContextValues = useDefaultContextValues()

  return contextValues ?? defaultContextValues
}
